import Vue from 'vue'

const autoScroll = {

  bind(el, binding) {
    const selectWrap = el.querySelector('.el-table__body-wrapper')

    setInterval(() => {
      selectWrap.scrollTop += 24

      if ((selectWrap.scrollTop + selectWrap.clientHeight) >= selectWrap.scrollHeight) {
        selectWrap.scrollTop = 0
      }

    }, 3000)

  }

}

export default Vue.directive('autoScroll', autoScroll)
